import { observer } from 'mobx-react-lite';
import { useTypedParams } from 'react-router-typesafe-routes/dom';

import { AppPage } from 'app/common/app-page/features/app-page';
import * as PageNotifications from 'app/common/notifications/features/page-notifications';
import { appRoute } from 'app/railways/router/routes';

import { PageContent } from '../../../../../ui';
import { PersonDetails } from './person-details';

export const DetailPersonPage = observer(() => {
  const { passengerId } = useTypedParams(appRoute.PERSON.DETAILS);

  return (
    <AppPage perm="PERM_PERSON_READ">
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <PageNotifications.Provider>
          <PageContent>
            <PageNotifications.Render>
              {(notifications) => notifications}
            </PageNotifications.Render>
          </PageContent>

          <PageContent>
            <PersonDetails id={passengerId} />
          </PageContent>
        </PageNotifications.Provider>
      </div>
    </AppPage>
  );
});
